import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { usePerfil } from '../../context/PerfilContext';
import { useTareas } from '../../context/TareasContext';
import { claveDia, esMia, mediodia } from '../../utils/tareas';
import { ChevronRight, ListChecks } from 'lucide-react';

/**
 * En el inicio: lo que te toca hoy y lo que se te ha quedado atrás. No sale
 * si no hay nada, para no meter ruido.
 */
export const HoyTareas: React.FC = () => {
  const { user } = useAuth();
  const { tieneModulo } = usePerfil();
  const { tareas, casas } = useTareas();
  if (!tieneModulo('tareas')) return null;

  const porCasa = new Map(casas.map(c => [c.id, c]));
  const hoy = claveDia(mediodia(new Date()));
  const mias = tareas.filter(t => t.activa && esMia(t, porCasa.get(t.casaId), user?.uid));
  const deHoy = mias.filter(t => claveDia(t.fecha) === hoy);
  const atrasadas = mias.filter(t => claveDia(t.fecha) < hoy);
  if (!deHoy.length && !atrasadas.length) return null;

  const nombres = deHoy.slice(0, 3).map(t => `${t.icono} ${t.nombre}`).join(' · ');
  const resto = deHoy.length > 3 ? ` y ${deHoy.length - 3} más` : '';

  return (
    <Link to="/tareas"
      className="mb-4 flex items-center gap-3 p-4 rounded-xl border border-lumbre-200 dark:border-lumbre-800
                 bg-lumbre-50 dark:bg-lumbre-900/20 hover:shadow-md transition">
      <ListChecks className="w-5 h-5 shrink-0 text-lumbre-600 dark:text-lumbre-400" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-gray-900 dark:text-white">
          {deHoy.length ? `Hoy te ${deHoy.length === 1 ? 'toca una tarea' : `tocan ${deHoy.length} tareas`}` : 'Tienes tareas atrasadas'}
        </p>
        <p className="text-xs text-gray-600 dark:text-gray-400 truncate">
          {deHoy.length ? nombres + resto : ''}
          {atrasadas.length > 0 && (
            <span className="text-red-600 dark:text-red-400">
              {deHoy.length ? ' · ' : ''}{atrasadas.length} {atrasadas.length === 1 ? 'atrasada' : 'atrasadas'}
            </span>
          )}
        </p>
      </div>
      <ChevronRight className="w-4 h-4 text-gray-400 shrink-0" />
    </Link>
  );
};
